'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { FeatherAlertTriangle, FeatherCalendar, FeatherPlus } from '@subframe/core';
import { Badge, Button, EmptyState, Loader } from '@/shared/components/ui';
import { useCalendariosFeriados } from '../hooks/useCalendariosFeriados';
import { CriarCalendarioDialog } from './CriarCalendarioDialog';
import { HistoricoFeriadosDialog } from './HistoricoFeriadosDialog';
import { SimularPrazoDialog } from './SimularPrazoDialog';
function formatarData(iso: string): string {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return '—';
  return data.toLocaleDateString('pt-BR');
}
export function CalendariosListaContainer() {
  const $ = _c(41);
  const {
    calendarios,
    status,
    salvando,
    criarCalendario,
    anosFaltando
  } = useCalendariosFeriados();
  const router = useRouter();
  const [dialogAberto, setDialogAberto] = useState(false);
  const [anoSugerido, setAnoSugerido] = useState(undefined);
  const [simularAberto, setSimularAberto] = useState(false);
  const [historicoAberto, setHistoricoAberto] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ano => {
      setAnoSugerido(ano);
      setDialogAberto(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const abrirNovo = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-brand-50 flex h-12 w-12 items-center justify-center rounded-[16px]"><FeatherCalendar className="text-brand-600 h-6 w-6" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-4">{t1}<div className="flex flex-col"><h1 className="text-heading-2 font-heading-2 text-default-font">Calendário de feriados</h1><span className="text-body font-body text-subtext-color">Base de feriados por ano usada no cálculo de dias úteis (prazos, lembretes e cobranças)</span></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button variant="neutral-secondary" onClick={() => setSimularAberto(true)}>Simular prazo</Button>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button variant="neutral-secondary" onClick={() => setHistoricoAberto(true)}>Histórico</Button>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-wrap items-center justify-between gap-4">{t2}<div className="flex flex-wrap items-center gap-2">{t3}{t4}<Button variant="brand-primary" icon={<FeatherPlus />} onClick={() => abrirNovo()}>Novo calendário</Button></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== anosFaltando || $[7] !== status) {
    t6 = status === "succeeded" && anosFaltando.length > 0 ? <div className="border-warning-200 bg-warning-50 flex flex-wrap items-center justify-between gap-3 rounded-[16px] border border-solid p-4"><div className="flex items-center gap-2"><FeatherAlertTriangle className="text-warning-700 h-5 w-5" /><span className="text-body font-body text-warning-700">{anosFaltando.length === 1 ? `O calendário de ${anosFaltando[0]} ainda não foi configurado. Prazos que vencem nesse ano ficarão bloqueados.` : `Os calendários de ${anosFaltando.join(" e ")} ainda não foram configurados. Prazos que vencem nesses anos ficarão bloqueados.`}</span></div><div className="flex flex-wrap gap-2">{anosFaltando.map(ano_0 => <Button key={ano_0} variant="neutral-secondary" size="small" onClick={() => abrirNovo(ano_0)}>Configurar {ano_0}</Button>)}</div></div> : null;
    $[6] = anosFaltando;
    $[7] = status;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== status) {
    t7 = status === "loading" ? <div className="flex h-40 w-full items-center justify-center"><Loader size="large" /></div> : null;
    $[9] = status;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== status) {
    t8 = status === "failed" ? <EmptyState icon={<FeatherCalendar />} title={"N\xE3o foi poss\xEDvel carregar os calend\xE1rios"} description="Tente novamente em instantes." /> : null;
    $[11] = status;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== calendarios || $[14] !== status) {
    t9 = status === "succeeded" && calendarios.length === 0 ? <EmptyState icon={<FeatherCalendar />} title={"Nenhum calend\xE1rio cadastrado ainda"} description={"Crie o calend\xE1rio de um ano para come\xE7ar a calcular prazos."} action={<Button variant="brand-primary" icon={<FeatherPlus />} onClick={() => abrirNovo()}>Novo calendário</Button>} /> : null;
    $[13] = calendarios;
    $[14] = status;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== calendarios || $[17] !== router || $[18] !== status) {
    t10 = status === "succeeded" && calendarios.length > 0 ? <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">{calendarios.map(calendario => <button key={calendario.ano} type="button" onClick={() => router.push(`/admin-geral/secretaria/feriados/${calendario.ano}`)} className="bg-default-background hover:border-brand-300 flex flex-col gap-3 rounded-[16px] border border-solid border-neutral-200 p-4 text-left transition-colors"><div className="flex w-full items-center justify-between"><span className="text-heading-3 font-heading-3 text-default-font">{calendario.ano}</span><Badge variant="neutral">{calendario.totalFeriados}{" "}{calendario.totalFeriados === 1 ? "feriado" : "feriados"}</Badge></div><span className="text-caption font-caption text-subtext-color">Atualizado em {formatarData(calendario.atualizadoEm)}</span></button>)}</div> : null;
    $[16] = calendarios;
    $[17] = router;
    $[18] = status;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t11 = <div className="bg-default-background flex w-full flex-col gap-4 rounded-[16px] border border-solid border-neutral-200 p-5">{t7}{t8}{t9}{t10}</div>;
    $[20] = t10;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== anoSugerido || $[26] !== criarCalendario || $[27] !== dialogAberto || $[28] !== salvando) {
    t12 = <CriarCalendarioDialog open={dialogAberto} onOpenChange={setDialogAberto} salvando={salvando} anoSugerido={anoSugerido} onCriar={criarCalendario} />;
    $[25] = anoSugerido;
    $[26] = criarCalendario;
    $[27] = dialogAberto;
    $[28] = salvando;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ano_1 => {
      setSimularAberto(false);
      abrirNovo(ano_1);
    };
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== simularAberto) {
    t14 = <SimularPrazoDialog open={simularAberto} onOpenChange={setSimularAberto} onConfigurarAno={t13} />;
    $[31] = simularAberto;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== historicoAberto) {
    t15 = <HistoricoFeriadosDialog open={historicoAberto} onOpenChange={setHistoricoAberto} />;
    $[33] = historicoAberto;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t11 || $[36] !== t12 || $[37] !== t14 || $[38] !== t15 || $[39] !== t6) {
    t16 = <div className="flex w-full flex-col gap-6 p-9">{t5}{t6}{t11}{t12}{t14}{t15}</div>;
    $[35] = t11;
    $[36] = t12;
    $[37] = t14;
    $[38] = t15;
    $[39] = t6;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
}